/* ─── Aggregate stats bar (inline, from API) ─── */
const StatsBar = ({ stats, t }) => {
  if (!stats) return null;
  const { total, sources, types, date_from, date_to } = stats;
  if (!total) return null;

  let rangeLabel = "";
  if (date_from && date_to) {
    const fmt = (d) =>
      new Date(d).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
    rangeLabel = `${fmt(date_from)} – ${fmt(date_to)}`;
  }

  return (
    <div
      className="flex items-center gap-2 text-[11px] whitespace-nowrap mr-2"
      style={{ color: t.textMuted }}
    >
      <span>{total} results</span>
      {sources != null && (
        <>
          <span style={{ opacity: 0.3 }}>·</span>
          <span>
            {sources} source{sources !== 1 ? "s" : ""}
          </span>
        </>
      )}
      {types != null && (
        <>
          <span style={{ opacity: 0.3 }}>·</span>
          <span>
            {types} type{types !== 1 ? "s" : ""}
          </span>
        </>
      )}
      {rangeLabel && (
        <>
          <span style={{ opacity: 0.3 }}>·</span>
          <span>{rangeLabel}</span>
        </>
      )}
    </div>
  );
};

export default StatsBar;
